import axios from "axios";
import { isEmpty } from "lodash";
import { ErrorAlert } from "../../utils/Alerts";
import { handleRequestHeaders } from "./headersManager";

const source = axios.CancelToken.source();

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 100000,
    validateStatus: false,
});

instance.interceptors.request.use(
    (request) => {
        return handleRequestHeaders(request);
    },
    (error) => {
        Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        let result = null;
        switch (response.status) {
            case 200:
            case 201:
            case 202:
            case 204:
                result = response?.data;
                break;
            case 401:
                if (response?.data?.path !== "/notifications/custom-token")
                    ErrorAlert(
                        "Your session has expired! please refresh your page."
                    );
                // refreshToken(axios.interceptors.response.eject(interceptor));
                break;
            case 409:
                result = { conflict: true };
                break;
            case 410:
                result = { expired: true };
                break;
            case 404:
                ErrorAlert("Not Found! Couldn't get this resource.");
                break;
            default:
                ErrorAlert(
                    isEmpty(response?.data?.message)
                        ? "Unhandled exception."
                        : response?.data?.message
                );
                break;
        }

        return result;
    },
    (error) => {
        if (error.status !== 401) {
            return Promise.reject(error);
        }
        // axios.interceptors.response.eject(interceptor);
        // return refreshToken();
    }
);

export { instance, source };
